import { render, staticRenderFns } from "./GeolocPage.vue?vue&type=template&id=2524ac3c&"
import script from "./GeolocPage.vue?vue&type=script&lang=js&"
export * from "./GeolocPage.vue?vue&type=script&lang=js&"
import style0 from "./GeolocPage.vue?vue&type=style&index=0&id=2524ac3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports